import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Box, Button, Card, Container, Divider, Fab, FormControl, Grid, Stack, Table, TableBody, TableContainer, TableCell, TableHead, TablePagination, TableRow, TextField, Typography, Paper, MenuItem, InputLabel, Select, IconButton } from '@mui/material';
import { KeyboardArrowLeftRounded, Add as AddIcon } from '@mui/icons-material';
import { Link as RouterLink, useParams } from 'react-router-dom';
import Scrollbar from '../components/scrollbar/Scrollbar';
import SendIcon from '@mui/icons-material/Send';
import { updateIssue, userDetail, getInspectorList } from './qualityApi'
import { useNavigate } from "react-router-dom";
import { getLocalStorageItem } from '../../common/localStorageUtils';

import { FILE_NAME_VALIDATION_ERROR, QUALITY_ROLES } from '../../common/constants';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { Delete as DeleteIcon } from '@mui/icons-material';
import { BaseURL, authKey } from '../../common/URLs';
import { capitalizeFunction, fileNameValidation } from '../../common/commonValidations';
import { toast } from 'react-toastify';
import { ConfirmationPopover } from '../../common/commonPopovers/confirmationPopover';
import { SubmitIcon } from '../../common/icons';
import apiClient from '../../axios';

function IssueATC1() {
    const { issueNumber } = useParams();
    const navigate = useNavigate()

    const [issueDetails, getIssueDetails] = useState([]);
    const [insName, setInsName] = useState('');
    const [insEmail, setInsEmail] = useState('');
    const [updateReport, setAddReport] = useState()
    const [updateIssueById, getUpdateIssueById] = useState([])
    const [insDetails, getInsDetails] = useState([]);
    const [isEnabled, setisEnabled] = useState(false);

    const [selectedFiles, setSelectedFiles] = useState([]);
    const [docedit, setDocedit] = useState(false);
    const [getInsRole, setGetInsRole]=useState();
    const [logModalOpenSubmit, setLogModalOpenSubmit] = useState(false);
    const handleLogModalCloseSubmit = () => setLogModalOpenSubmit(false);
    const handleLogModalOpenSubmit = () => setLogModalOpenSubmit(true);

    useEffect(() => {
        userDetail(issueNumber).then((res) => {
            getIssueDetails(res);
            let userType = localStorage.getItem("role");
            setGetInsRole(userType)
            // if (res && res.inspectorEmail && userType == QUALITY_ROLES.Inspector) {
            //     setInsEmail(res.inspectorEmail);
            // } 
            if (userType == 'Qty-Inspectors') {
                setDocedit(true)
            }
            if (res && res.inspectorEmail) {
                setInsEmail(res.inspectorEmail);
            }
            setSelectedFiles(res.qualityDocumentMasterEntity)
            var userDetail = localStorage.getItem('role')

            if (userDetail == QUALITY_ROLES.QualityModuleIncharge) {
                setisEnabled(true);
            } else {
                if(issueDetails.qualityIssueDtlsEntity.status=="approved")
                {
                    setisEnabled(true);
                }
                setisEnabled(false);
            }
        }).catch((e) => {
            console.log(e);
        })

        getInspectorList().then((res) => {
            getInsDetails(res);
            // console.log(res, "ins Details")
        }).catch((err) => {
            console.log(err);
        })
    }, [])

    // const rows = issueDetails

    function updateReportHandler(e) {
        setAddReport(e.target.value);

        // const result = e.target.value.replace(/[^\w\s]/gi, '')
        const result = e.target.value.replace(/[^\w\s\.\,]/gi, '')
        setAddReport(result)
    }

    const onConfirmSubmit = () => {
        handleLogModalCloseSubmit();
        let getIssueById = {
            "qualityIssueDtlsEntity": {
                "issueNumber": issueNumber,
                "inspectorEmail": insEmail,
                "actionTakenClosureReport": updateReport,
                "inspectorName": insName,
                "action": "",
                "status": issueDetails.qualityIssueDtlsEntity.status
            },
            qualityDocumentMasterEntity:
                selectedFiles
        }
        updateIssue(getIssueById, getUpdateIssueById).then((res) => {
            console.log(getIssueById, "issueDet");
            console.log(res, "response")
            toast.success(res.description)
            navigate('../issueatc')
        })
    }

    const submitClosure = () => {
        if (updateReport == "") {
            toast.error("Please add review")
        } else {
            handleLogModalOpenSubmit();
        }
    }

    const downloadDocument = (file, type) => {
        console.log("file", file)

        return fetch(BaseURL + '/document/v1/Blob/download_document'
            ,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    AuthKey: authKey,
                },
                body: JSON.stringify({
                    "fileName": file.documentBlobName,
                    "containerName": "qualityfiles",
                    "file": ""
                })
            })
            .then((response) => response.blob()
            )
            .then((blob) => {
                const fileName = file?.documentName
                const splittedName = fileName.split('.')
                const fileExtension = splittedName[splittedName.length - 1];
                let fileType;
                switch (fileExtension) {
                    case 'pdf':
                        fileType = 'application/pdf';
                        break;
                    case 'png':
                        fileType = 'image/png';
                        break;
                    case 'jpg':
                        fileType = 'image/jpeg';
                        break;
                    case 'jpeg':
                        fileType = 'image/jpeg';
                        break;
                    default:
                        fileType = 'application/octet-stream';
                }
                const url = window.URL.createObjectURL(new Blob([blob], { type: fileType }));
                const newWindow = window.open(url, '_blank');
                newWindow.focus();
                // loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                // loaderService.hideLoader()
            });
    }


    function handleDelete(file, index) {
        apiClient
            .post(
                BaseURL + "/document/v1/Blob/delete_document",
                {
                    "fileName": file.documentBlobName,
                    "containerName": "qualityfiles",
                },
                {
                    headers: {

                        "Authorization": "Bearer " + getLocalStorageItem('id_token')
                    },
                }
            )
            .then((response) => {

                response?.data?.isSuccess === true ? toast.success(response?.data?.message) : toast.error(response?.data?.message);
                // response?.data?.isSuccess === true && 

                if (response?.data?.isSuccess === true && file.id != null) {

                    let getIssueById = {
                        "qualityIssueDtlsEntity": {
                            "issueNumber": issueNumber,
                            "inspectorEmail": insEmail,
                            "actionTakenClosureReport": updateReport,
                            "inspectorName": insName,
                            "action": ""
                        },
                        qualityDocumentMasterEntity:
                            [{
                                "id": file.id,
                                "isActive": 0,
                                "documentContainerName": 'qualityfiles',
                                "issueNumber": issueNumber
                            }]

                    }
                    updateIssue(getIssueById, getUpdateIssueById).then((res) => {
                        userDetail(issueNumber).then((response) => {
                            //  console.log('rrrrrrrrrrreeeeee', response);
                            //   getTicketDetails(ticketNumber)
                            const newArr = [...selectedFiles];
                            newArr.splice(index, 1);
                            setSelectedFiles(newArr)
                            getIssueDetails(response);


                        }).catch((error) => {
                            console.log(error);
                        })

                    })
                }
                else {
                    // getTicketDetails(ticketNumber)
                    const newArr = [...selectedFiles];
                    newArr.splice(index, 1);
                    setSelectedFiles(newArr)
                }

            })

            .catch(function (error) {
                console.log(error);
                toast.error(error.message);
                //   loaderService.hideLoader();
            });

    }


    function getDocumentUploadDetails(file) {
        // setDocumentcheck(true)
        console.log('new file dddddddd', file);
        const formData = new FormData();
        formData.append("file", file);
        formData.append("fileName", file.name);
        formData.append("containerName", "qualityfiles");

        apiClient
            .post(
                BaseURL + "/document/v1/Blob/upload_document",
                formData,
                {
                    headers: {

                        AuthKey: authKey,

                    },
                }
            )
            .then((response) => {
                response?.data?.isSuccess === true ? toast.success(response?.data?.message) : toast.error(response?.data?.message);
                // response?.data?.isSuccess === true && 
                if (response?.data?.isSuccess === true) {
                    const blobResponse = response?.data?.blobResponse
                    const tempArr = {
                        "documentName": blobResponse.fileName,
                        "documentBlobName": blobResponse.blobFileName,
                        "issueNumber": issueNumber,
                        "isActive": 1,
                        "documentContainerName": 'qualityfiles',
                    };
                    //setSelectedFiles(tempArr);
                    setSelectedFiles((prevState) => ([...prevState, tempArr]));
                    /// it is to store the previous state
                    console.log('new selected filesffffffffff', selectedFiles);
                }

            })
            .catch(function (error) {
                console.log(error);
                toast.error(error.message);
                //   loaderService.hideLoader();
            });
    }

    function handleDocumentChange(e) {
        // console.log(e,'trrrrrrrrrrrrr')
        const choosenFiles = Array.prototype.slice.call(e.target.files)
        let total = 0;
        let pattern = /.*\..*\..*/g;
        choosenFiles.map((file) => {
            total = total + file.size
        })

        if (total > 5000000) {
            toast.error('File size should less than 5MB')
            return false;
            //setErrorMessage({ ...errorMessage, fileUploadError: 'One of the selected file size is more than 5MB, select the files which size less than 5MB' });
        }
        else if (choosenFiles.some(file => pattern.test(file.name.toLowerCase()))) {
            toast.error("Double extension file detected pls select proper file")
            return false;
        }
        else if (choosenFiles.some(file => fileNameValidation(file.name))) {
            toast.error(FILE_NAME_VALIDATION_ERROR)
            return false;
        }
        else if (choosenFiles.every(file => file.type == "image/png" || file.type == "image/jpg"
            || file.type == "image/jpeg" || file.type == "application/pdf")) {
            //   setSelectedFiles(e.target.files);
            //setErrorMessage({ ...errorMessage, fileUploadError: '' });
            choosenFiles.map((file) => {
                getDocumentUploadDetails(file)
            })
        }
        else {
            //  setErrorMessage({ ...errorMessage, fileUploadError: 'Please select the file type jpg,pdf,jpeg ' });
            toast.error('Please select the file type jpg, pdf, jpeg')
            return false;
        }
    };


    function handleInspectorChange(e) {
        setInsEmail(e.target.value)
        const tempEmailArr = insDetails.filter((item) => (item.emailAddress == e.target.value));
        setInsName(tempEmailArr[0].firstname + " " + tempEmailArr[0].lastname);
    }

    // useEffect(() => {
    //     var userDetail = localStorage.getItem('role')
    //     if (userDetail == QUALITY_ROLES.QualityModuleIncharge) {
    //         setisEnabled(true);
    //     } else {
    //         // if(issueDetails.qualityIssueDtlsEntity.status=="approved")
    //         // {
    //         //     setisEnabled(true);
    //         // }
    //         setisEnabled(false);
    //     }
    // }, [])


    //console.log(issueDetails.qualityIssueDtlsEntity.status, "status")

    return (
        <>
            <Helmet>
                <title> Issue & ATC 1 | ABEPL </title>
            </Helmet>
            <Container maxWidth="xl">
                <Typography variant="h4" sx={{ mb: 2 }}>
                    <Fab component={RouterLink} to='../issueatc' size="small" aria-label="back">
                        <KeyboardArrowLeftRounded />
                    </Fab> Issue & ATC 1
                </Typography>
                <Card>
                    <Stack spacing={2} sx={{ m: 2 }}>
                        <Grid container>
                            <Grid item md={3}>
                                <Card sx={{ p: 1, width: 'fit-content', }}>
                                    <Stack direction="row" spacing={2}>
                                        <Typography variant='subtitle2'>Issue Number</Typography>
                                        <Divider orientation="vertical" flexItem />
                                        <Typography variant='subtitle2'>{issueNumber}</Typography>
                                    </Stack>
                                </Card>
                            </Grid>
                        </Grid>

                        <Grid container>
                            <Grid item xs={12}>
                                <Card>
                                    <Scrollbar>
                                        <TableContainer component={Paper}>
                                            <Table sx={{ minWidth: 650 }} size="small" aria-label="simple table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>Work Order ID</TableCell>
                                                        <TableCell>Inspection Category</TableCell>
                                                        <TableCell align="center">Material Code</TableCell>
                                                        <TableCell align="center">Inspector</TableCell>
                                                        <TableCell align="center">Recorded Quantity</TableCell>
                                                        <TableCell align="center">New Recorded Quantity</TableCell>
                                                        <TableCell align="center">Bundle ID </TableCell>
                                                        <TableCell align="center">Deviation</TableCell>
                                                        <TableCell align='center'>Consignmet ID</TableCell>
                                                        <TableCell align="center">Invoice Status</TableCell>
                                                        <TableCell align="center">Created On </TableCell>
                                                        <TableCell align="center">Created By </TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    <TableRow
                                                        key={issueDetails.qualityIssueDtlsEntity?.issueNumber}
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                        <TableCell align="center">{issueDetails.qualityIssueDtlsEntity?.inspectionWorkOrderId}</TableCell>
                                                        <TableCell component="th" scope="row" style={{ textTransform: 'capitalize' }}>
                                                            {issueDetails.qualityIssueDtlsEntity?.inspectionCategory}
                                                        </TableCell>
                                                        <TableCell align="center">{issueDetails.qualityIssueDtlsEntity?.materialCode}</TableCell>
                                                        <TableCell align="center">
                                                            {/* <Button variant="outlined" size="small" startIcon={<AddCircleIcon />} onClick={addInspector}> Add</Button> */}
                                                            <FormControl variant="standard" fullWidth>
                                                                {
                                                                    console.log(issueDetails.qualityIssueDtlsEntity?.status == "Open" || issueDetails.qualityIssueDtlsEntity?.status == "Clarification", "********************")
                                                                }
                                                                {(issueDetails.qualityIssueDtlsEntity?.status == "Open" || issueDetails.qualityIssueDtlsEntity?.status == "Clarification") && getInsRole == "Qty-Incharge" ?
                                                                    (<Select
                                                                        labelId="demo-simple-select-standard-label"
                                                                        id="demo-simple-select-standard"
                                                                        value={insEmail}
                                                                        label="Inspector Name"
                                                                        style={{ fontSize: "13px" }}
                                                                        onChange={handleInspectorChange}
                                                                        disabled={!isEnabled}
                                                                    >
                                                                        <MenuItem value="">Select</MenuItem>
                                                                        {
                                                                            insDetails.map(function (inspector, i) {
                                                                                return <MenuItem value={inspector?.emailAddress ?? ""} key={inspector.id} style={{ fontSize: "14px" }}>
                                                                                    {(inspector?.firstname + " " + inspector?.lastname).toUpperCase() || "Inspector Name"}
                                                                                </MenuItem>
                                                                            })
                                                                        }
                                                                    </Select>)
                                                                    :
                                                                    (<TableCell component="th" scope="row" style={{ textTransform: 'capitalize' }}>
                                                                        {/* {issueDetails.firstname} */}
                                                                        {issueDetails['qualityIssueDtlsEntity']?.inspectorName}
                                                                        {/* { getInsName} */}
                                                                    </TableCell>)
                                                                }

                                                            </FormControl>
                                                        </TableCell>
                                                        <TableCell align="center">{issueDetails.qualityIssueDtlsEntity?.recordedQuantity}</TableCell>
                                                        <TableCell align="center">{issueDetails.qualityIssueDtlsEntity?.newQuantity || 'NA'}</TableCell>
                                                        <TableCell align="center" style={{ width: '150px', fontSize: '12px' }}>{issueDetails.qualityIssueDtlsEntity?.lotNumber}</TableCell>
                                                        <TableCell align="center">{issueDetails.qualityIssueDtlsEntity?.deviation}</TableCell>
                                                        <TableCell align="center">{issueDetails.qualityIssueDtlsEntity?.consignmentId}</TableCell>
                                                        <TableCell align="center">{issueDetails.qualityIssueDtlsEntity?.invoiceOnHoldTillQCClearance}</TableCell>
                                                        <TableCell align='center'>{issueDetails.qualityIssueDtlsEntity?.createdOnStr}</TableCell>
                                                        <TableCell align='center'>{issueDetails.qualityIssueDtlsEntity?.createdBy}</TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Scrollbar>
                                </Card>
                            </Grid>
                        </Grid>

                        <Grid container>
                            <Grid item xs={12}>
                                <Card>
                                    <Scrollbar>
                                        <TableContainer component={Paper}>
                                            <Table sx={{ minWidth: 650 }} size="small" aria-label="simple table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>Quality Parameter</TableCell>
                                                        <TableCell align="center">Measurement location</TableCell>
                                                        <TableCell align="center">Measuring Instrument</TableCell>
                                                        <TableCell align="center"> Restricted / Unrestricted</TableCell>
                                                        <TableCell align="center">Actual Quantity</TableCell>
                                                        <TableCell align="center">Tolerance Limit</TableCell>
                                                        <TableCell align="center">Updated On</TableCell>
                                                        <TableCell align="center">Updated By </TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {/* {issueDetails.map((row) => ( */}
                                                    <TableRow
                                                        key={issueDetails.qualityIssueDtlsEntity?.id}
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                        <TableCell component="th" scope="row">
                                                            {issueDetails?.qualityIssueDtlsEntity?.qualityParameter}
                                                        </TableCell>
                                                        <TableCell align="center"> {issueDetails.qualityIssueDtlsEntity?.measurementLocation} </TableCell>
                                                        <TableCell align="center"> {issueDetails.qualityIssueDtlsEntity?.measuringInstrument} </TableCell>
                                                        <TableCell align="center"> {issueDetails.qualityIssueDtlsEntity?.restricted} </TableCell>
                                                        <TableCell align="center"> {issueDetails.qualityIssueDtlsEntity?.measured_quantity} </TableCell>
                                                        <TableCell align="center"> {issueDetails.qualityIssueDtlsEntity?.toleranceLimit} </TableCell>
                                                        <TableCell align='center'>{issueDetails.qualityIssueDtlsEntity?.updatedOnStr}</TableCell>
                                                        <TableCell align='center'>{issueDetails.qualityIssueDtlsEntity?.updtdBy}</TableCell>
                                                    </TableRow>
                                                    {/* ))} */}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Scrollbar>
                                </Card>
                            </Grid>
                        </Grid>

                        <Grid container>
                            <Grid item xs={12}>
                                <Card sx={{ p: 2 }}>
                                    <Typography variant="h5" component="h3">
                                        Action taken closure report
                                    </Typography>
                                    <TextField
                                        sx={{ mt: 2 }}
                                        id="outlined-textarea"
                                        label="Action taken closure report"
                                        placeholder="Type text here"
                                        style={{ width: '60%', background: isEnabled ? '#ccc' : '#fff' }}
                                        multiline
                                        rows={4}
                                        value={updateReport}
                                        onChange={updateReportHandler}
                                        disabled={isEnabled}
                                        inputProps={{
                                            maxLength: 500
                                        }}
                                    />
                                </Card>
                            </Grid>
                        </Grid>
                        <Box sx={{ paddingLeft: '3%' }} >

                            {/* <Box component="outlined" sx={{  borderRadius: '16px', border: '2px dashed ', borderColor: 'secondary.main' }}> */}
                            <Grid >
                                {docedit && (
                                    <>
                                        <p>Attachments</p>
                                        <Card style={{ backgroundColor: '#E7EBE8', width: '25%' }}>

                                            <Stack direction="column"
                                                justifyContent="center"
                                                alignItems="center">

                                                <IconButton disabled color="secondary" >
                                                    <CloudUploadIcon color="warning"
                                                        fontSize="large"
                                                    />
                                                </IconButton>
                                                <Button variant="contained" component="label"  >Browse
                                                    <input id='fileUpload' name='fileUpload' type="file" multiple

                                                        onChange={(e) => { handleDocumentChange(e); e.target.value = null }}

                                                        //  accept='application/pdf, image/png'
                                                        //  disabled={fileLimit}
                                                        placeholder="Upload"
                                                        style={{ display: "none" }}
                                                    />

                                                </Button>
                                                <label style={{ fontSize: '10px' }}>supported files:pdf,png,jpg,jpeg.</label>
                                                {/* </Box> */}
                                            </Stack>
                                        </Card>
                                    </>
                                )}
                                <Grid item xs={12} sm={6} md={6}>
                                    {selectedFiles.map((file, index) => (
                                        <Stack direction="row">
                                            📁
                                            &nbsp;
                                            <Typography color="neutral" > {file?.documentName}
                                                &nbsp;
                                                &nbsp;

                                                <RemoveRedEyeIcon color="primary" onClick={() => downloadDocument(file, "Create")} variant="outlined" size="sm" />

                                            </Typography>
                                            {docedit && <DeleteIcon onClick={() => handleDelete(file, index)} />}
                                            {/* /* <DeleteIcon color="error" fontSize="small" sx={{ mt: 0.5 }}   /> */}
                                        </Stack>
                                    ))
                                    }
                                </Grid>

                            </Grid>
                        </Box>

                        <Stack style={{ display: 'inline-block' }}>
                            <Button variant="contained" size="medium" style={{ float: 'right' }} onClick={submitClosure} endIcon={<SubmitIcon />}>Submit</Button>
                        </Stack>
                    </Stack>
                </Card>
            </Container>
            <ConfirmationPopover onOpen={logModalOpenSubmit} onConfirm={onConfirmSubmit} action="Submit" onClose={handleLogModalCloseSubmit} />
         </>
    )
}

export default IssueATC1